module.exports = __webpack_public_path__ + "static/media/awks.eb6e71da.png";